import { render, staticRenderFns } from "./addChegua.vue?vue&type=template&id=0d73a0dc&scoped=true&"
import script from "./addChegua.vue?vue&type=script&lang=js&"
export * from "./addChegua.vue?vue&type=script&lang=js&"
import style0 from "./addChegua.vue?vue&type=style&index=0&id=0d73a0dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73a0dc",
  null
  
)

export default component.exports